module.exports = __webpack_public_path__ + "static/img/no_favorites_bg.03d18dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_favorites_bg.png
// module id = bLOP
// module chunks = 1